angular.module('pe4h').run(['$templateCache', function($templateCache) {
  $templateCache.put('components/about/about.html',
    '<update-title title="Contact Us | Available 24/7 | PEforHire.com"></update-title>\n' +
    '<update-meta name="description" content="Email us at info@PEforHire.com or call 1 (415) 952-7344 (PE4H) for help. P.E. For Hire is headquartered in the San Francisco Bay Area."></update-meta>\n' +
    '<div ng-cloak>\n' +
    '    <section class="content display about parallax" style="background-image:url(\'assets/img/engineer-mesuring-land.jpg\')">\n' +
    '        <div class="gradient">\n' +
    '            <div class="container">\n' +
    '                <h1>Connecting Professional Engineers and Projects</h1>\n' +
    '                <h3>P.E. For Hire</h3>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </section>\n' +
    '\n' +
    '    <section id="company" class="content bg-grey">\n' +
    '        <div class="container">\n' +
    '            <div class="row">\n' +
    '                <div class="col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2">\n' +
    '                    <h2>We are based in California</h2>\n' +
    '                    <div class="hex-center">\n' +
    '                        <div class="hexagon-lg alt">\n' +
    '                            <i class="icon-compass"></i>\n' +
    '                        </div>\n' +
    '                        <div class="hexagon-lg alt">\n' +
    '                            <i class="icon-engineer"></i>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                    <p class="lead">P.E. for Hire takes the needle out of the haystack for Professional Engineers looking for projects to bid on, and for contractors and consultants looking for the perfect engineering subcontractors.</p>\n' +
    '\n' +
    '                    <p class="lead">It\'s an online platform specifically designed to help Professional Engineers find great projects to bid on and to help contractors and consultants find qualified Professional Engineers for their projects.</p>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </section>\n' +
    '\n' +
    '    <section id="contact" class="content contact">\n' +
    '        <div class="container">\n' +
    '            <h2 class="mb40">Contact</h2>\n' +
    '            <div class="row">\n' +
    '                <div class="col-sm-6 col-sm-offset-1">\n' +
    '                    <h3 class="text-left text-muted mb30">Send us a message</h3>\n' +
    '                    <form id="contactForm" name="contactForm" ng-submit="contactUs()">\n' +
    '                        <div class="form-group">\n' +
    '                            <input ng-model="name" ng-maxlength="200" type="text" class="form-control input-lg" id="nameinput" name="nameInput" placeholder="Name *" onfocus="this.placeholder=\'\'" onblur="this.placeholder=\'Name *\'" required="true">\n' +
    '                            <div class="help-block" ng-class="{ \'errors\': contactForm.nameInput.$touched && contactForm.nameInput.$invalid }" ng-messages="contactForm.nameInput.$error" ng-if="contactForm.nameInput.$touched">\n' +
    '                                <p ng-message="required">This field is required</p>\n' +
    '                                <p ng-message="maxlength">This field is too long</p>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                        <div class="form-group">\n' +
    '                            <input ng-model="email" ng-maxlength="200" type="email" class="form-control input-lg" id="emailInput" name="emailInput" placeholder="Email *" onfocus="this.placeholder=\'\'" onblur="this.placeholder=\'Email *\'" required="true">\n' +
    '                            <div class="help-block" ng-class="{ \'errors\': contactForm.emailInput.$touched && contactForm.emailInput.$invalid }" ng-messages="contactForm.emailInput.$error" ng-if="contactForm.emailInput.$touched">\n' +
    '                                <p ng-message="required">This field is required</p>\n' +
    '                                <p ng-message="maxlength">This field is too long</p>\n' +
    '                                <p ng-message="email">This field is invalid</p>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                        <div class="form-group">\n' +
    '                            <textarea ng-model="message" ng-maxlength="2000" class="form-control" rows="6" id="messageInput" name="messageInput" placeholder="Message *" onfocus="this.placeholder=\'\'" onblur="this.placeholder=\'Message *\'" required="true"></textarea>\n' +
    '                            <div class="help-block" ng-class="{ \'errors\': contactForm.messageInput.$touched && contactForm.messageInput.$invalid }" ng-messages="contactForm.messageInput.$error" ng-if="contactForm.messageInput.$touched">\n' +
    '                                <p ng-message="required">This field is required</p>\n' +
    '                                <p ng-message="maxlength">This field is too long</p>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                        <div class="form-group">\n' +
    '                            <label class="select">\n' +
    '                                <select ng-model="role" id="order_find_us" class="form-control input-lg empty" onchange="document.getElementById(\'order_find_us\').className=\'form-control input-lg\';" name="order">\n' +
    '                                    <option value="" selected disabled>What is your role?</option>\n' +
    '                                    <option class="dark" value="I am the Hiring Party">I am the Hiring Party</option>\n' +
    '                                    <option class="dark" value="I am an Engineer">I am an Engineer</option>\n' +
    '                                    <option class="dark" value="Other">Other</option>\n' +
    '                                </select>\n' +
    '                            </label>\n' +
    '                        </div>\n' +
    '                        <div class="row mb40">\n' +
    '                            <div class="col-xs-7 col-sm-6 col-md-4"></div>\n' +
    '                            <div class="col-xs-5 col-sm-3 col-md-5 text-left"></div>\n' +
    '                            <div class="col-xs-12 col-sm-3 col-md-3">\n' +
    '                                <div class="clearfix visible-xs mt30"></div>\n' +
    '                                <button ng-disabled="contactForm.$invalid" type="submit" class="btn btn-primary btn-lg btn-block">Send</button>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </form>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="col-sm-4 col-sm-offset-1 text-left">\n' +
    '                    <h3 class="text-left text-muted mb30">Share your story</h3>\n' +
    '                    <p class="">We would like to hear from you about your project and experience. Feel free to just say hello... we will respond as soon as possible.</p>\n' +
    '                    <hr>\n' +
    '                    <ul class="list-inline">\n' +
    '                        <li>Support:</li>\n' +
    '                        <li>\n' +
    '                            <a href="mailto:info@peforhire.com">info@peforhire.com</a>\n' +
    '                        </li>\n' +
    '                    </ul>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </section>\n' +
    '</div>\n' +
    '');
}]);
